import { PropsWithChildren } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { cx } from '@twind/core';

export type DrawerProps = PropsWithChildren<{
  isOpen: boolean;
  onClose: () => void;
  className?: string;
  overlayClassName?: string;
  containerClassName?: string;
  disableOverlayClose?: boolean;
  id?: string;
}>;

export default function Drawer({
  isOpen,
  onClose,
  className,
  overlayClassName,
  containerClassName,
  disableOverlayClose = false,
  id,
  children,
}: DrawerProps) {
  return (
    <div
      id={id}
      aria-hidden={!isOpen}
      className={cx('absolute inset-0 z-50', containerClassName)}
      style={{ pointerEvents: isOpen ? 'auto' : 'none' }}
    >
      <AnimatePresence>
        {isOpen && (
          <motion.div
            key="overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.15 }}
            onClick={disableOverlayClose ? undefined : onClose}
            className={cx('absolute inset-0 bg-black/30', overlayClassName)}
            aria-hidden
          />
        )}
      </AnimatePresence>

      <AnimatePresence>
        {isOpen && (
          <motion.section
            key="drawer"
            role="dialog"
            aria-modal="true"
            initial={{ y: '100%' }}
            animate={{ y: 0 }}
            exit={{ y: '100%' }}
            transition={{ duration: 0.2 }}
            className={cx(
              'absolute inset-x-0 bottom-0',
              'bg-white shadow-xl rounded-t-xl overflow-hidden',
              'max-h-[calc(var(--app-height) - 10px)]',
              className
            )}
          >
            <div className="flex flex-col">{children}</div>
          </motion.section>
        )}
      </AnimatePresence>
    </div>
  );
}
